<section class="section">
  <mat-form-field appearance="standard">
    <mat-label>Производитель</mat-label>
    <input matInput type="text" [formControl]="searchControl" placeholder="Поиск..." />
    <button mat-icon-button matSuffix (click)="clear()">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="checkbox-container">
    <mat-checkbox
      [checked]="isSelected(brand)"
      (change)="toggle(brand)"
      *ngFor="let brand of brands"
      color="primary"
      >{{ brand.description }}</mat-checkbox
    >
  </div>
</section>
